import { useNavigate } from "react-router-dom";
import InfoGenesis from "../../../assets/img/Featured/kiosk-retail.png";
import Eatec from "../../../assets/img/Featured/tablet-eatec.png";
import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import "./index.scss";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const GiftsPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page giftsPage">
            <Header />
            <div className="page-header">Hotel</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Gift Shop</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Ensure that the perfect shirt or hat is in stock at
                    the right price for every guest. With InfoGenesis
                    POS and Agilysys Eatec procurement and
                    perpetual inventory system, not only will you have
                    the items your guests desire, but they can also
                    seamlessly pay by charging to their hotel room,
                    credit cards, gift cards or cash.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Gift Shop", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <img src={InfoGenesis} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Gift Shop", "Eatec");
                    addFlow("Eatec");
                    navigate("/solutions/eatec")}}>
                    <img src={Eatec} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        Eatec
                    </div>          
                </div>
            </FeaturedSolutions>
        </div>
    )
}

export default GiftsPage; 